module.exports = "/_next/static/images/game-tournament-58c08f099b1db5a556a1ff0b42725d92.png";